module.exports = __webpack_public_path__ + "static/clock-d45b739960139dda618bef28ee00d15a.svg";